<template>
<div class="chapter">
<div class="inner_page">
<p class="bt" id="d6e1694"><span class="small"><b>THE</b></span><br/><span style="font-size:1.5em;"><b>EVERYTHING</b></span><sub><span class="small"><span class="small">®</span></span></sub><br/><span style="font-size:1.2em;"><b>SELF-ESTEEM</b><br/> <b>BOOK</b></span></p>
<p class="h1c" id="d6e1804"><span class="small"><b>Boost your confidence, achieve inner<br/> strength, and learn to love yourself</b></span></p>
<p class="h2c" id="d6e1884"><b>Robert M. Sherfield, Ph.D.</b><br/><br/><br/><br/></p>
<p class="ser"><img alt="logo" id="d14e190" src="images/logo.jpg" style="max-width: 100%"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Sher_9781440522697_epub_c1_r1.vue?669c4b13